import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {toastr} from "react-redux-toastr";
import { API_CONNECTIONS } from "../../../services/api/api.urls";
import { api } from "../../../services/api/api.service";
import { TryCatch } from "../../../services/TryCatch";
import { COMPANY_ABBR } from "../../../common/constants/company";
import { PaginationProps } from "../../../common/types/PaginationProps";

interface IGetConnectionsResponse {
    totalItems: 0,
    pageNum: 0,
    pageSize: 0,
    message: string,
    isOK: true,
    sort: 0,
    sortField: string,
    search: string,
    items: ILoggingConnectionItem[],
    totalPages: number
}

interface ILoggingConnectionsState {
    connections: ILoggingConnectionItem[],
    pagination: PaginationProps
}

export interface ILoggingConnectionItem {
    id: number,
    user: string,
    client: string,
    addressIP: string,
    message: string,
    status: string,
    timeStart: string
}

const initialState: ILoggingConnectionsState = {
    connections: [],
    pagination: {
        activePage: 1,
        pageSize: 10,
        totalPages: 1
    }
}

export const getConnections = createAsyncThunk<IGetConnectionsResponse, string, { rejectValue: string }>(
    'logging/get-connections',
    async (query, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.get(`${API_CONNECTIONS}/?${query}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result}`);
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)


export const deleteConnection = createAsyncThunk<{ id: number | string }, string | number, { rejectValue: string }>(
    'logging/delete-connection',
    async (id, {rejectWithValue}) => {
        const result = await TryCatch(
            () => api.delete(`${API_CONNECTIONS}/${id}`).then(res => res.data)
        );
        if (!result.success) {
            toastr.error(COMPANY_ABBR, `${result}`);
            return rejectWithValue(result.error);
        }
        return result.data;
    }
)


export const LoggingConnectionsSlice = createSlice({
    name: 'loggingConnections',
    reducers: {
        setPageNum: (state, action) => {
            state.pagination.activePage = action.payload
        },
        changePageSize:(state,action) => {
            state.pagination.pageSize = action.payload
        }
    },
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getConnections.pending, (state: ILoggingConnectionsState) => {

            })
            .addCase(getConnections.fulfilled, (state: ILoggingConnectionsState, action) => {
                state.connections = action.payload.items
                state.pagination.totalPages = action.payload.totalPages
            })

            .addCase(deleteConnection.fulfilled, (state: ILoggingConnectionsState, action) => {
                state.connections = state.connections.filter(con => con.id !== action.meta.arg)
            })

    }
})
export const { setPageNum, changePageSize } = LoggingConnectionsSlice.actions
export default LoggingConnectionsSlice.reducer;



